/**
 * Form 组件的 emit 事件声明
 */
export const formEmits = [
  /** 校验全部通过后触发 */
  'submit',
  /** 校验失败时触发 */
  'failed',
  /** 已注册字段的值变更时触发 */
  'valuesChange',
];

/**
 * FormItem 组件的 emit 事件声明
 */
export const formItemEmits = [
  /** 字段校验完成时触发 */
  'validate',
];
